import React from 'react';
import { useEffect } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import useTheme from '../../MobileAppUrl/UseTheme'
import useDarkTheme from '../../MobileAppUrl/UseDarkTheme'
import GoBack from '../BackButton/GoBack';
import { useTranslation } from 'react-i18next';

export default function TermaConditions(props: any) {
    const { t } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { theme, toggleTheme } = useTheme();
    const { darktheme, toggleDarkTheme } = useDarkTheme();


    useEffect(() => {
        const { theme } = props.match.params;

        if (theme === undefined) {
            localStorage.removeItem("theme");
            return;
        }
        if (theme === "night") {
            toggleDarkTheme();
            return;
        }
        if (theme === "day") {
            toggleTheme();
            return;
        }
    }, [props.match.params]);


    return (
        <> <Header />
            <section className='terms-conditions'>
                <div className="container">
                    <div className='about-us position-relative'>
                        <div className="back-btn-position web-backbtn">
                            <GoBack />
                        </div>
                        <h2 className='about-title'>{t('TERMS_TITLE')}</h2>
                        {/* <h5>{t('TERMS_SUBTITLE')}</h5> */}
                        <p>{t('TERMS_READ')}</p>
                        <section id="section-1" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC1_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC1_LI1')}</li>
                                <li>{t('TERMS_SEC1_LI2')}</li>
                                <li>{t('TERMS_SEC1_LI3')}</li>
                                <li>{t('TERMS_SEC1_LI4')}</li>
                            </ol>
                        </section>

                        {/* Section 2: Information About Us */}
                        <section id="section-2" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC2_TITLE')}</h2>
                            <p>
                                {t('TERMS_SEC2_P1')}
                            </p>
                        </section>

                        {/* Section 3: Changes to These Terms */}
                        <section id="section-3" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC3_TITLE')}</h2>
                            <p>
                                {t('TERMS_SEC3_P1')}
                            </p>
                        </section>

                        {/* Section 4: Changes to Our Site */}
                        <section id="section-4" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC4_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC4_LI1')}</li>
                                <li>{t('TERMS_SEC4_LI2')}</li>
                            </ol>
                        </section>

                        {/* Section 5: Other Terms */}
                        <section id="section-5" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC5_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC5_LI1')}</li>
                                <li>{t('TERMS_SEC5_LI2')}</li>
                            </ol>
                        </section>

                        {/* Section 6: Accessing Our Site */}
                        <section id="section-6" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC6_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC6_LI1')}</li>
                                <li>{t('TERMS_SEC6_LI2')}</li>
                                <li>{t('TERMS_SEC6_LI3')}</li>
                                <li>{t('TERMS_SEC6_LI4')}</li>
                            </ol>
                        </section>

                        <section id="section-7" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC7_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC7_LI1')}</li>
                                <li>{t('TERMS_SEC7_LI2')}</li>
                                <li>{t('TERMS_SEC7_LI3')}</li>
                                <li>{t('TERMS_SEC7_LI4')}</li>
                            </ol>
                        </section>
                        <section id="section-8" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC8_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC8_LI1')}</li>
                                <li>{t('TERMS_SEC8_LI2')}</li>
                                <li>{t('TERMS_SEC8_LI3')}</li>
                                <li>{t('TERMS_SEC8_LI4')}</li>
                            </ol>
                        </section>
                        <section id="section-9" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC9_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5">
                                <li>{t('TERMS_SEC9_LI1')}</li>

                            </ol>
                        </section>

                        {/* Section 10: Intellectual Property Rights */}
                        <section id="section-10" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC10_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5 space-y-2">
                                <li>{t('TERMS_SEC10_LI1')}</li>
                                <li>{t('TERMS_SEC10_LI2')}</li>
                                <li>{t('TERMS_SEC10_LI3')}</li>
                                <li>{t('TERMS_SEC10_LI4')}</li>
                                <li>{t('TERMS_SEC10_LI5')}</li>
                                <li>{t('TERMS_SEC10_LI6')}</li>
                                <li>{t('TERMS_SEC10_LI7')}</li>
                            </ol>
                        </section>

                        {/* Section 11: No Reliance on Information */}
                        <section id="section-11" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC11_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5 space-y-2">
                                <li>{t('TERMS_SEC11_LI1')}</li>
                                <li>{t('TERMS_SEC11_LI2')}</li>
                                <li>{t('TERMS_SEC11_LI3')}</li>
                            </ol>
                        </section>

                        {/* Section 12: Limitation of Liability */}
                        <section id="section-12" className="mb-6">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC12_TITLE')}</h2>
                            <ol className="list-decimal-terms pl-5 space-y-2">
                                <li>{t('TERMS_SEC12_LI1')}</li>
                                <li>{t('TERMS_SEC12_LI2')}</li>
                                <li>{t('TERMS_SEC12_LI3')}</li>
                                <li>{t('TERMS_SEC12_LI4')}</li>
                                <li>{t('TERMS_SEC12_LI5')}</li>
                                <li>{t('TERMS_SEC12_LI6')}</li>
                            </ol>
                        </section>
                        {/* Section 13: User Warranty */}
                        <section id="section-13" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC13_TITLE')}</h2>
                            <ol className="list-decimal-terms">
                                <li>{t('TERMS_SEC13_LI1')}</li>
                                <li>{t('TERMS_SEC13_LI2')}</li>
                            </ol>
                        </section>

                        {/* Section 14: Viruses */}
                        <section id="section-14" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC14_TITLE')}</h2>
                            <ol className="list-decimal-terms">
                                <li>{t('TERMS_SEC14_LI1')}</li>
                                <li>{t('TERMS_SEC14_LI2')}</li>
                                <li>{t('TERMS_SEC14_LI3')}</li>
                            </ol>
                        </section>

                        {/* Section 15: Linking to Our Site */}
                        <section id="section-15" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC15_TITLE')}</h2>
                            <p>
                                {t('TERMS_SEC15_P1')}
                            </p>
                        </section>

                        {/* Section 16: Third Party Links and Resources */}
                        <section id="section-16" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC16_TITLE')}</h2>
                            <ol className="list-decimal-terms">
                                <li>{t('TERMS_SEC16_LI1')}</li>
                                <li>{t('TERMS_SEC16_LI2')}</li>
                            </ol>
                        </section>

                        {/* Section 17: Applicable Law */}
                        <section id="section-17" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC17_TITLE')}</h2>
                            <p>
                                {t('TERMS_SEC17_P1')}
                            </p>
                        </section>

                        {/* Section 18: Contact Us */}
                        <section id="section-18" className="mb-8">
                            <h2 className="text-set-terms-and-condition">{t('TERMS_SEC18_TITLE')}</h2>
                            <p>
                                {t('TERMS_SEC18_P1')}
                            </p>
                        </section>



                        {/* Continue with 13, 14, 15... */}



                    </div>
                </div>
                <Footer />
            </section>
        </>
    )
}
